/**
 * 平台
 */

import { HTTP_ALB } from '../axios'

//  平台列表
export const getmedialist = params => {
  return HTTP_ALB.get('/system/media/list', params)
}

// 添加平台
export const addmedia = params => {
  return HTTP_ALB.post('/system/media/add', params)
}
// 编辑平台
export const editmedia = params => {
  return HTTP_ALB.post('/system/media/edit', params)
}

// 项目类型列表
export const projectList = params => {
  return HTTP_ALB.get('/system/project/list', params)
}

// 项目类型添加
export const projectAdd = params => {
  return HTTP_ALB.post('/system/project/add', params)
}

// 项目类型-编辑
export const projectEdit = params => {
  return HTTP_ALB.post('/system/project/edit', params)
}
